<h3>{{data.title}}</h3>
<p [innerHTML]="data.content"></p>
